import React from 'react'

import * as S from './styled'

const Pagination = ({children}) => {
    return (
        <S.PaginationWrapper>
            {children}
        </S.PaginationWrapper>
    )

}

export default Pagination;